import {CheckoutLinkActionType} from './CheckoutLinkActionHelper';
import React, {useContext, useState} from 'react';
import {CheckoutLinksDataContext} from '../CheckoutLinksDataContext';
import {MenuItem} from '@material-ui/core';
import {EditPaymentLinkDialog} from '../dialogs/EditPaymentLinkDialog';

const CheckoutLinkEditAction = React.forwardRef<HTMLLIElement, CheckoutLinkActionType>(({ checkoutLink, setMenuAnchor, label }, ref) => {
  const [openDialog, setOpenDialog] = useState(false);
  const { reload } = useContext(CheckoutLinksDataContext);
  return (
    <>
      <MenuItem
        ref={ref}
        onClick={() => {
          setMenuAnchor(null);
          setOpenDialog(true);
        }}
      >
        {label}
      </MenuItem>

      {openDialog && (
        <EditPaymentLinkDialog
          isOpen={openDialog}
          checkoutLink={checkoutLink}
          onCancel={() => {
            setOpenDialog(false);
            reload();
          }}
        />
      )}
    </>
  );
});

export default CheckoutLinkEditAction;
